export default __webpack_public_path__ + "static/media/Rectangle.1a6c5c6c.png";